import { render, staticRenderFns } from "./GlobalAudio.vue?vue&type=template&id=d5e3a56e&scoped=true&"
import script from "./GlobalAudio.vue?vue&type=script&lang=js&"
export * from "./GlobalAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e3a56e",
  null
  
)

export default component.exports